import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { PreHeadingAlignment, PreHeadingModel, PreHeadingModelItem } from './pre-heading.model';

@Component({
  selector: 'pre-heading',
  template: `
    <div id="PreHeadingComponent" class="pre-heading" [style.background]="this.data.background_color">
      <div class="pre-heading-container " [ngClass]="{'horizontal-scroll' : this.data.horizontal_scroll }">
        <ul class="-eva-3-pt-md -eva-3-pb-md pre-heading-link-list" [ngStyle]="{'justify-content': getJustifyContentType()}">
          <li *ngFor="let item of data.items">
            <a class="eva-3-link pre-heading-link" [style.color]="getTextoColor(item)" [href]="item.link" (click)="onClick(item)" rel="nofollow">{{item.text}}</a>
          </li>
        </ul>
      </div>
    </div>
  `,
  styleUrls: ['./pre-heading.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PreHeadingComponent {
  @Input() position: number;
  @Input() uniqueId?: string;
  @Input() data: PreHeadingModel

  constructor(private upaService: UpaService) {
  }

  getJustifyContentType() {
    switch (this.data.alignment) {
      case PreHeadingAlignment.CENTER: return 'center';
      case PreHeadingAlignment.LEFT: return 'flex-start';
      case PreHeadingAlignment.RIGHT: return 'flex-end';
    }
  }

  getTextoColor(item: PreHeadingModelItem) {
    return item.color && item.color !== '' ? item.color : '#888888'
  }

  onClick(item) {
    this.upaService.trackClickTopic({
      label: item.text,
      moduleId: "PreHeadingModule",
      moduleIndex: this.position,
      target: UpaTarget.PREHEADING,
      href: item.link,
      uniqueId: this.uniqueId
    });
  }
}
